module.exports = __webpack_public_path__ + "img/23_29.2d376c91.png";